import React, { useState, useEffect, useRef } from "react";
import { useWebApp, useExpand } from "@vkruglikov/react-telegram-web-app";
import {
  getPaymentViewData,
  createPayment,
  cancelSubscription,
} from "../services/paymentService";

import { CheckCircle } from "react-feather";
import Sticker from "./Sticker";
import "../styles/payment.css";
function PaymentForm({ strings, language, user_id, paymentData }) {
  const webApp = useWebApp();
  const [initialLoading, setInitialLoading] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState("yearly_pro");
  const [error, setError] = useState(null);
  const [plans, setPlans] = useState([]);
  const [subscription, setSubscription] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState("");
  const [featureFlags, setFeatureFlags] = useState({});

  const bottomRef = useRef(null);

  const onShowMore = () => {
    setShowMoreOptions(true);
    window.Telegram.WebApp.ready(() => {
      window.Telegram.WebApp.expand();
    });
  };

  // For showing more payment plan options
  const [showMoreOptions, setShowMoreOptions] = useState(false);

  // Tooltip state and ref
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);

  const isProSelected =
    selectedPlan === "yearly_pro" ||
    selectedPlan === "monthly_pro" ||
    selectedPlan === "yearly_pro_special" ||
    selectedPlan === "monthly_pro_special" ||
    selectedPlan === "yearly_pro_high" ||
    selectedPlan === "monthly_pro_high" ||
    selectedPlan === "yearly_pro_low" ||
    selectedPlan === "monthly_pro_low";

  useEffect(() => {
    // Close tooltip if clicked outside
    function handleClickOutside(e) {
      window.Telegram.WebApp.HapticFeedback.selectionChanged();
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        setShowTooltip(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (showMoreOptions) {
      // let React render the extra cards, then ask Telegram to re-measure
      setTimeout(() => {
        webApp.expand();
      }, 0);

      // setTimeout(() => {
      //   bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      // }, 50);
    }
  }, [showMoreOptions, webApp]);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const moscowTime = new Date(
        now.toLocaleString("en-US", { timeZone: "Europe/Moscow" })
      );
      const midnight = new Date(moscowTime);
      midnight.setHours(24, 0, 0, 0);

      const diff = midnight - moscowTime;

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      return language === "ru"
        ? `00д ${hours.toString().padStart(2, "0")}ч ${minutes
            .toString()
            .padStart(2, "0")}м ${seconds.toString().padStart(2, "0")}с`
        : `00d ${hours.toString().padStart(2, "0")}h ${minutes
            .toString()
            .padStart(2, "0")}m ${seconds.toString().padStart(2, "0")}s`;
    };

    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [language]);

  useEffect(() => {
    const paymentPlans = paymentData.payment_plans.sort((a, b) => {
      if (a.id === "yearly" || a.id === "yearly_high" || a.id === "yearly_low")
        return -1;
      if (
        a.id === "yearly_pro" ||
        a.id === "yearly_pro_high" ||
        a.id === "yearly_pro_low"
      )
        return b.id === "yearly" ||
          b.id === "yearly_high" ||
          b.id === "yearly_low"
          ? 1
          : -1;
      if (
        a.id === "monthly" ||
        a.id === "monthly_high" ||
        a.id === "monthly_low"
      )
        return b.id.includes("yearly") ? 1 : -1;
      return 1;
    });

    if (
      paymentData.feature_flags.price === "pro_only" ||
      featureFlags.price === "subgram" ||
      !featureFlags.price
    ) {
      paymentData.payment_plans.sort((a, b) =>
        a.id.includes("monthly") ? -1 : 1
      );
    }

    if (
      paymentData.feature_flags.price === "more_options" ||
      paymentData.feature_flags.price === "full"
    ) {
      paymentData.payment_plans.sort((a, b) => {
        if (
          (a.id.includes("yearly") ||
            a.id.includes("yearly_high") ||
            a.id.includes("yearly_low")) &&
          !a.id.includes("pro")
        )
          return -1;
        if (
          (b.id.includes("yearly") ||
            b.id.includes("yearly_high") ||
            b.id.includes("yearly_low")) &&
          !b.id.includes("pro")
        )
          return 1;
        if (
          a.id.includes("yearly_pro") ||
          a.id.includes("yearly_pro_high") ||
          a.id.includes("yearly_pro_low")
        )
          return -1;
        if (
          b.id.includes("yearly_pro") ||
          b.id.includes("yearly_pro_high") ||
          b.id.includes("yearly_pro_low")
        )
          return 1;
        if (
          (a.id.includes("monthly") ||
            a.id.includes("monthly_high") ||
            a.id.includes("monthly_low")) &&
          !a.id.includes("pro")
        )
          return -1;
        if (
          (b.id.includes("monthly") ||
            b.id.includes("monthly_high") ||
            b.id.includes("monthly_low")) &&
          !b.id.includes("pro")
        )
          return 1;
        return 0;
      });
    }

    setSubscription(paymentData.subscription);
    setPlans(paymentPlans);
    setFeatureFlags(paymentData.feature_flags);

    if (paymentPlans.some((p) => p.id === "yearly_pro")) {
      setSelectedPlan("yearly_pro");
    } else if (paymentPlans.some((p) => p.id === "yearly_pro_high")) {
      setSelectedPlan("yearly_pro_high");
    } else if (paymentPlans.some((p) => p.id === "yearly_pro_low")) {
      setSelectedPlan("yearly_pro_low");
    } else if (paymentPlans.some((p) => p.id === "yearly_pro_special")) {
      setSelectedPlan("yearly_pro_special");
    } else {
      setSelectedPlan("yearly");
    }

    if (
      paymentData.feature_flags.price === "subgram" ||
      (Object.keys(paymentData.feature_flags).length > 0 &&
        !paymentData.feature_flags.price)
    ) {
      if (paymentPlans.some((p) => p.id === "yearly_pro_special")) {
        setSelectedPlan("yearly_special");
      } else if (paymentPlans.some((p) => p.id === "yearly_high")) {
        setSelectedPlan("yearly_high");
      } else if (paymentPlans.some((p) => p.id === "yearly_low")) {
        setSelectedPlan("yearly_low");
      } else {
        setSelectedPlan("yearly");
      }
    }

    setInitialLoading(false);
  }, [
    webApp.initDataUnsafe?.user?.id,
    user_id,
    paymentData,
    paymentData.feature_flags,
    paymentData.feature_flags.price,
  ]);

  const handleCancelSubscription = async () => {
    try {
      const userId = user_id;
      if (!userId) throw new Error("User ID not available");

      await cancelSubscription(userId);
      const paymentData = await getPaymentViewData(userId);
      setSubscription(paymentData.subscription);
      setShowCancelModal(false);
    } catch (err) {
      setShowCancelModal(false);
      setError(err.message);
    }
  };

  const handleResubscribe = async () => {
    window.Telegram.WebApp.HapticFeedback.notificationOccurred("success");
    try {
      setSubscription({ ...subscription, active: false });
    } catch (err) {
      setError(err.message);
    }
  };

  const handlePaymentProvider = async (provider) => {
    window.Telegram.WebApp.HapticFeedback.notificationOccurred("success");
    try {
      const userId = user_id;
      if (!userId) throw new Error("User ID not available");

      setShowPaymentModal(false);
      setIsPaymentLoading(true);

      const paymentRes = await createPayment(provider, selectedPlan, {
        telegramId: userId,
      });

      webApp.setBackgroundColor("#ffffff");

      if (provider === "stripe") {
        window.location.href = paymentRes.sessionUrl;
      } else if (provider === "yoomoney") {
        window.location.href = paymentRes.paymentUrl;
      }
    } catch (err) {
      setError(err.message);
      setIsPaymentLoading(false);
      webApp.setBackgroundColor("var(--tg-theme-bg-color)");
    }
  };

  // Show either all plans or only pro plans based on feature flag
  const visiblePlans =
    featureFlags.price === "pro_only"
      ? plans.filter((plan) => plan.id.includes("pro"))
      : featureFlags.price === "subgram" || !featureFlags.price
      ? plans.filter((plan) => !plan.id.includes("pro"))
      : showMoreOptions
      ? plans
      : plans.filter(
          (plan) =>
            plan.term === "yearly" ||
            plan.id.includes("yearly_high") ||
            plan.id.includes("yearly_low")
        );

  const renderPlanPrice = (plan) => {
    const isPro = plan.id.includes("pro");
    const displayName = plan.display_name;
    let nameWithoutPro = displayName;
    let proLabel = null;

    if (isPro && displayName.endsWith("Pro")) {
      nameWithoutPro = displayName.substring(0, displayName.length - 3);
      proLabel = <span className="pro-gradient">Pro</span>;
    }

    let { price_rub, price_usd } = plan;

    const multiplier = plan.id.includes("monthly") ? 2 : 5;

    let old_price_rub = plan.price_rub * multiplier;
    let old_price_usd = Math.round(plan.price_usd * multiplier * 100) / 100;

    const price =
      language === "ru" ? (
        <>
          {price_rub}
          <span>₽</span>
        </>
      ) : (
        <>
          <span>$</span>
          {price_usd}
        </>
      );
    const old_price =
      language === "ru" ? (
        <>
          {old_price_rub}
          <span>₽</span>
        </>
      ) : (
        <>
          <span>$</span>
          {old_price_usd}
        </>
      );

    const termLabel =
      plan.term === "monthly" ? strings.perMonth : strings.perYear;

    const term = plan.term === "yearly" ? strings.yearly : strings.monthly;

    return (
      <div className="plan-price-container">
        <div className="plan-details">
          <span className="plan-name">
            {nameWithoutPro} {proLabel}
          </span>
          <span className="plan-term">{term}</span>
        </div>
        <div className="price-right">
          <div className="price-details">
            <span className="plan-price-old">{old_price}</span>
            <span className="plan-price">{price}</span>
            <span className="price-term">{termLabel}</span>
          </div>
          <div className="discount-badge">
            -{plan.term === "yearly" ? "80" : "50"}%
          </div>
        </div>
      </div>
    );
  };

  if (initialLoading || isPaymentLoading) {
    return (
      <div className="payment-container center-content">
        <Sticker type="loading" size={180} />
        {isPaymentLoading && (
          <div className="loading-text">
            <h3>{strings.preparingPayment}</h3>
            <p>{strings.pleaseWait}</p>
          </div>
        )}
      </div>
    );
  }

  if (error) {
    return (
      <div className="payment-container center-content">
        <Sticker type="main" size={180} />
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="payment-container">
      {/* --- STYLES --- */}
      <style>{`
        .payment-container {
          padding: 0 10px;
          padding-bottom: 60px;
          color: var(--tg-theme-text-color);
          background: var(--tg-theme-bg-color);
        }
        .payment-container.center-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .sticker-container {
          width: 100%;
          display: flex;
          justify-content: center;
        }
        .main-content h1 {
          font-size: 28px;
          font-weight: bold;
          margin: 0;
          text-align: center;
          background: linear-gradient(190deg, #0390e8, #8a2be2);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .benefits-list {
          margin: 0 0 8px 0;
          padding: 0;
          list-style: none;
        }
        .benefit-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 4px;
          font-size: 16px;
          line-height: 1.4;
          padding: 0;
        }
        .check-icon {
          margin-right: 12px;
          margin-top: 2px;
          color: #0390e8;
          flex-shrink: 0;
          stroke-width: 3px;
        }
        .check-icon-pro {
          color: #8a2be2;
        }
        .not-selected .check-icon-pro {
          color: rgba(122,122,122,0.8);
        }
        .benefit-item span {
          text-align: left;
        }
        .benefit-item.not-selected span {
          color: rgba(122,122,122,0.8);
        }
        .pro-gradient {
          background: linear-gradient(200deg, #0390e8, #8a2be2);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          font-weight: bold;
        }
        .not-selected .pro-gradient {
          background: rgba(122,122,122,0.8);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .pro-label {
          border: 1px solid #8a2be2;
          border-radius: 4px;
          padding: 0 4px;
          margin-right: 4px;
        }
        .not-selected .pro-label {
          border-color: rgba(122,122,122,0.8);
        }
        .time-left {
          color: #ff3b30;
          font-weight: 500;
        }
        .time-left span {
          font-family: "Courier New", monospace;
          font-weight: 900;
        }
        .plans-container {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin: 12px;
          margin-top: 2px;
        }
        .plan-card {
          background: var(--tg-theme-secondary-bg-color);
          border-radius: 12px;
          padding: 4px 16px;
          cursor: pointer;
          border: 1px solid transparent;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.2s ease;
          position: relative;
        }
        .plan-card.selected {
          border-color: var(--tg-theme-button-color);
          background: rgba(47, 128, 237, 0.1);
        }
        .plan-card[class*="pro"].selected {
          border-color: #8a2be2;
          background: rgba(138, 43, 226, 0.1);
        }
        .plan-card:nth-child(2)::before {
          content: "${strings.recommended}";
          position: absolute;
          top: -10px;
          left: 10px;
          background: linear-gradient(190deg, #0390e8, #8a2be2);
          color: white;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: bold;
        }
        .plan-price-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        }
        .plan-details {
          display: flex;
          flex-direction: column;
          align-items: start;
        }
        .plan-name {
          font-size: 20px;
          font-weight: 500;
          color: var(--tg-theme-text-color);
        }
        .plan-term {
          font-size: 14px;
          color: var(--tg-theme-hint-color);
        }
        .price-right {
          display: flex;
          gap: 20px;
          align-items: center;
        }
        .price-details {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .plan-price-old {
          color: var(--tg-theme-hint-color);
          text-decoration: line-through;
          font-size: 16px;
          opacity: 0.7;
        }
        .plan-price {
          color: #2f80ed;
          font-size: 20px;
          font-weight: 500;
        }
        .plan-price span {
          font-weight: 200;
        }
        .price-term {
          font-size: 12px;
          color: #2f80ed;
        }
        .discount-badge {
          border: 1px solid #ff3b30;
          background: none;
          color: #ff3b30;
          padding: 2px 4px;
          border-radius: 6px;
          font-size: 18px;
          font-weight: 500;
        }
        .continue-button {
          margin: 0 10px;
          margin-bottom: 16px;
          width: calc(100% - 20px);
          margin-top: 0;
          height: 48px;
          background: #2f80ed;
          border-radius: 12px;
          border: none;
          color: white;
          font-size: 20px;
          font-weight: bold;
          cursor: pointer;
          transition: opacity 0.2s ease;
        }
        .selected-pro {
          background: linear-gradient(135deg, #0390e8, #8a2be2);
        }
        .continue-button:active {
          opacity: 0.7;
        }
        .more-options-button {
          margin: 0 10px;
          margin-bottom: 20px;
          width: calc(100% - 20px);
          background: transparent;
          border: none;
          font-size: 18px;
          font-weight: 500;
          cursor: pointer;
          transition: opacity 0.2s ease;
          color: #2f80ed;
        }
        .more-options-button:active {
          opacity: 0.7;
        }
        .subscription-info {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }
        .subscription-info h2 {
          margin: 16px 0;
          font-size: 24px;
          font-weight: 500;
        }
        .subscription-info p {
          margin: 8px 0;
          font-size: 16px;
          color: var(--tg-theme-hint-color);
        }
        .cancel-button {
          appearance: none;
          background: transparent;
          border: none;
          border-radius: 8px;
          color: #ff4444;
          cursor: pointer;
          display: flex;
          font-size: 16px;
          font-weight: 500;
          justify-content: center;
          min-height: 48px;
          padding: 0 16px;
          width: 100%;
          align-items: center;
          transition: opacity 0.15s ease-in-out;
        }
        .cancel-button:active {
          opacity: 0.6;
        }
        .error-message {
          color: #ff4444;
          text-align: center;
        }
        .loading-text {
          text-align: center;
          margin-top: 20px;
        }
        .loading-text h3 {
          margin: 0 0 8px 0;
          font-size: 18px;
        }
        .loading-text p {
          margin: 0;
          color: var(--tg-theme-hint-color);
        }

        /* Modal styles */
        .modal-overlay {
          position: fixed;
          top: 0; bottom: 0; left: 0; right: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: flex-end;
          z-index: 1000;
          transition: opacity 0.3s ease;
          opacity: 0;
          pointer-events: none;
          height: 100vh;
        }
        .modal-overlay.visible {
          opacity: 1;
          pointer-events: auto;
        }
        .modal-content {
          background: var(--tg-theme-bg-color);
          border-radius: 12px 12px 0 0;
          padding: 24px 20px;
          width: 100%;
          transform: translateY(100%);
          transition: transform 0.3s ease;
          position: relative;
        }
        .modal-overlay.visible .modal-content {
          transform: translateY(0);
        }
        .modal-content h3 {
          text-align: center;
          margin: 0 0 24px 0;
          font-size: 20px;
          font-weight: 500;
        }
        .cancel-confirm-button {
          background: #ff4444 !important;
        }

        /* Tooltip icon and popup */
        .tooltip-wrapper {
          position: relative;
          display: inline-block;
          margin-left: 4px;
        }
        .tooltip-icon {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: transparent;
          border: 1px solid #8a2be2;
          color: #8a2be2;
          font-size: 12px;
          cursor: pointer;
          flex-shrink: 0;
        }
        .not-selected .tooltip-icon {
          border: 1px solid gray;
        }
          
        .tooltip-popup {
          position: fixed;
          /* Center horizontally in the screen */
          left: 50%;
          transform: translateX(-50%);
          top: 280px;

          /* 90% width if desired */
          width: 90vw;
          max-width: 600px; /* optional limit */

          /* Appearance */
          background: var(--tg-theme-secondary-bg-color);
          color: var(--tg-theme-text-color);
          padding: 8px 12px;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
          z-index: 9999;
          font-size: 14px;
          border: 1px solid #8a2be2;
        }



      `}</style>

      {/* If user has an active subscription */}
      {subscription?.active && (
        <div className="subscription-info">
          <Sticker type="success" size={180} />
          <h2>{strings.subscriptionActive}</h2>
          <p>
            {strings.validUntil}:{" "}
            {new Date(subscription.expiration_date).toLocaleString(
              language === "ru" ? "ru-RU" : "en-US",
              {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              }
            )}
          </p>
          <p>
            {strings.subscriptionType}:{" "}
            {subscription?.[language === "ru" ? "name_ru" : "name_en"]}
          </p>
          <p>
            {strings.price}:{" "}
            {subscription.provider === "yoomoney"
              ? `${subscription?.price_rub}₽`
              : `$${subscription?.price_usd}`}
          </p>
          {subscription.auto_renew ? (
            <button
              className="cancel-button"
              onClick={() => setShowCancelModal(true)}
            >
              {strings.cancelSubscription}
            </button>
          ) : (
            <>
              <p>
                {strings.autoRenewal}: {strings.autoRenewalDisabled}
              </p>
              <button className={`continue-button`} onClick={handleResubscribe}>
                {strings.resubscribe}
              </button>
            </>
          )}
        </div>
      )}

      {/* If user does NOT have an active subscription */}
      {!subscription?.active && (
        <>
          <div className="main-content">
            <div ref={bottomRef} />
            <div className="sticker-container">
              <Sticker type="main" size={160} />
            </div>
            <h1>{strings.chattyUnlimited}</h1>
            <ul className="benefits-list">
              {strings.benefits.map((benefit, index) => (
                <li key={index} className="benefit-item">
                  <CheckCircle className="check-icon" size={18} />
                  <span>{benefit}</span>
                </li>
              ))}
              {/* PRO benefit with tooltip */}
              {!featureFlags.price || featureFlags.price == "subgram" ? (
                <></>
              ) : (
                <li
                  key={99}
                  className={`benefit-item ${
                    isProSelected ? "selected" : "not-selected"
                  }`}
                >
                  <CheckCircle
                    className={`check-icon check-icon-pro`}
                    size={18}
                  />
                  <span>
                    <span className="pro-gradient pro-label">Pro</span>
                    {strings.proBenefit}
                    {/* Tooltip icon and popup */}
                    <span className="tooltip-wrapper" ref={tooltipRef}>
                      <span
                        className="tooltip-icon"
                        onClick={() => setShowTooltip(!showTooltip)}
                      >
                        ?
                      </span>
                      {showTooltip && (
                        <div className="tooltip-popup">
                          {strings.proTooltip}
                        </div>
                      )}
                    </span>
                  </span>
                </li>
              )}
            </ul>
          </div>

          {/* {featureFlags.countdown !== "no" && (
            <div className="time-left">
              {strings.saleEnds} <span>{timeLeft}</span>
            </div>
          )} */}

          <div className="plans-container">
            {visiblePlans.map((plan) => (
              <div
                key={plan.id}
                className={`plan-card ${
                  plan.id.includes("pro") ? "plan-pro" : ""
                } ${selectedPlan === plan.id ? "selected" : ""}`}
                onClick={() => {
                  window.Telegram.WebApp.HapticFeedback.selectionChanged();
                  setSelectedPlan(plan.id);
                }}
              >
                {renderPlanPrice(plan)}
              </div>
            ))}
          </div>

          <button
            className={`continue-button ${isProSelected ? "selected-pro" : ""}`}
            onClick={() => {
              window.Telegram.WebApp.HapticFeedback.notificationOccurred(
                "success"
              );
              setShowPaymentModal(true);
            }}
          >
            {strings.continue}
          </button>

          {/* "More options" button */}
          {!showMoreOptions &&
            (featureFlags.price === "more_options" ||
              paymentData.feature_flags.price === "full") && (
              <button
                className="more-options-button"
                onClick={() => onShowMore()}
              >
                {strings.moreOptions}
              </button>
            )}
        </>
      )}

      {/* Payment Provider Modal */}
      <div
        className={`modal-overlay ${showPaymentModal ? "visible" : ""}`}
        onClick={() => {
          window.Telegram.WebApp.HapticFeedback.selectionChanged();
          setShowPaymentModal(false);
        }}
      >
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <h3>{strings.selectPaymentMethod}</h3>
          <div className="providers-container">
            <button
              className="provider-button"
              onClick={() => handlePaymentProvider("stripe")}
            >
              {strings.paymentWorld}
            </button>
            <button
              className="provider-button"
              onClick={() => handlePaymentProvider("yoomoney")}
            >
              {strings.paymentRu}
            </button>
          </div>
          <button
            className="back-button"
            onClick={() => setShowPaymentModal(false)}
          >
            {strings.close}
          </button>
        </div>
      </div>

      {/* Cancel Subscription Modal */}
      <div
        className={`modal-overlay ${showCancelModal ? "visible" : ""}`}
        onClick={() => setShowCancelModal(false)}
      >
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <h3>{strings.cancelSubscriptionConfirm}</h3>
          <div className="providers-container">
            <button
              className="provider-button cancel-confirm-button"
              onClick={handleCancelSubscription}
            >
              {strings.confirm}
            </button>
            <button
              className="provider-button"
              onClick={() => setShowCancelModal(false)}
            >
              {strings.close}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentForm;
